// Generated with `script/ts/get-slack-users`
export const allowedUsers = [
    {
        id: "U01RXM0DA3H",
        name: "brian",
        email: "brian@superwall.com"
    },
    {
        id: "U06Q44YNNKW",
        name: "nick",
        email: "nick@superwall.com"
    },
    {
        id: "U02909X396G",
        name: "jake",
        email: "jake@superwall.com"
    },
    {
        id: "U034TBTBLE7",
        name: "yusuf",
        email: "yusuf@superwall.com"
    },
    {
        id: "U038WPCFG93",
        name: "jonathandparra",
        email: "jonathan@superwall.com"
    },
    {
        id: "U03ER224PA6",
        name: "satoru",
        email: "satoru@superwall.com"
    },
    {
        id: "U03T5QBPVHQ",
        name: "kevziiq",
        email: "kevziiq@gmail.com"
    },
    {
        id: "U043QK6LP5Z",
        name: "bryandubno",
        email: "bryan@superwall.com"
    },
    {
        id: "U089MNJJUCF",
        name: "david",
        email: "david@superwall.com"
    },
    {
        id: "U07H402DF34",
        name: "christo",
        email: "christo@superwall.com"
    },
    {
        id: "U08L4H4HPC0",
        name: "duncan",
        email: "duncan@superwall.com"
    }
];
